.root {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transform: rotate(0);
  transition: opacity 195ms cubic-bezier(0.4, 0, 0.6, 1);
}

.subtitle {
  margin-top: 8px;
  margin-bottom: 8px;
}
